import color from "../../../../constants/color";

const style = {
  headerContainer:{
    display: {sm:"block", md:"flex"},
    justifyContent:"space-between",
    alignItems:"center",
    // paddingRight:3.5
  }, 
  leaveHeading: { 
    fontWeight: 600,
    fontSize: "20px", 
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text, 
    mt:1
  },
  BillHeading: {
    fontWeight:"500" ,
    color: color.lightText,
    mb:1,
  },
  dateInput:{
    width: "100%",
    my:1,


    "& .MuiInputBase-input": {
      padding: "7px 14px",
    }},

  jobButton: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A", 
    fontSize: "12px",
    mt:1,
  },

  inputSection: {
    display: {sx:"block", md: "flex"},
    justifyContent: "space-between",
    px: 2,
    alignItems: "center",
  },
  inputGrid: {
    display: {sx:"block", md: "flex"},
    justifyContent: "end",
    alignItems: "center",
    width: "100%"

  },

  inputLabel:{
    fontSize:"12px",
    fontWeight:"500",
    color:color.text
  },
  checkinBtns: {

    "& svg": {
      mr:1,
    },
    borderBottomRightRadius : 50, 
    borderTopRightRadius : 50, 

    backgroundColor: "#28AA4A",
    color: "#fff", 
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow:"none",

  },
  csvBtns: {
    borderBottomLeftRadius : 50, 
    borderTopLeftRadius : 50, 
    px:1,
    backgroundColor: color.card,
    color: color.text, 
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow:"none",

  },

  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary
  },
  deleteIcon: {
    p: 1,
    pb:0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red

  },

  inputContainer:{
    // width:{xs:"18em",md:"25em",},
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between"
  },
  inputContainerBox:{
    // width:{xs:"18em",md:"25em",},
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between",
    mb:1,
  },

  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    borderRadius:"30px",
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"5.5px 14px",
    },
    "& .MuiOutlinedInput-root":{
      padding:"0"
    },
    width:"100%"
  },

  card:{
    mt:2,
    backgroundColor:color.card,
    padding:"10%",
    borderRadius:"20px",
    display:"flex",
    alignItems:"center  ",
    justifyContent:"space-Between"
    // gridColumn:{ xs: "span 12", md: "span 3" }
  },
  cardBox:{
    mt:2,
    backgroundColor:color.card,
    padding:"10%",
    borderRadius:"20px",
    display:"flex",
    alignItems:"center  ",
    // gridColumn:{ xs: "span 12", md: "span 3" }
  },

  cards:{
    mt:2,
    backgroundColor:color.card,
    p:2,
    borderRadius:"20px",
    alignItems:"center  ",
    justifyContent:"space-Between"
    // gridColumn:{ xs: "span 12", md: "span 3" }
  },
  subTotal: {
    fontWeight: "500",
  },
  subTotals: {
    fontWeight: "500",
    borderTop: "1px solid #DEDEDE",

  },

  uploadSection: {
    px: 2,
    width: {xs: "100%", md: "55%"},

    "& .css-2y07vr":{
      py: "7px"

    }
  },
  leaveInputGrid: {
    display: {xs: "block", md: "flex"},
    alignItems: "center",
    justifyContent: "space-between"

  },
  leaveSheetGrid:{
    display: {xs: "block", md: "flex"},
    ml:{xs:0, md:2}, 
    mt:{xs:0, md:2}, 
    height:"fit-content"
  },
  leaveSheet: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "5px",
    px: 1,
    mr: 1,
    mb:{xs:1, md:0},
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    " & .css-0" : {
      display:"flex",

    },
  },
  closeIcon: {
    fontSize: "1rem",
    ml:2,
  },
  textHeading: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.lightText,

  },
  textBody: {
    fontSize: "16px",
    fontWeight: "500",
    // color: color.text,

  },
  textNumber: {
    fontSize: "18px",
    fontWeight: "700",
    // color: color.text,

  },

  iconSection: {
    backgroundColor: color.primary,
    borderRadius: "50%",
    mr:3,
    width: "55px",
    height: "55px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },
  bankSection: {
    backgroundColor: color.secondary,
    borderRadius: "50%",
    mr:3,
    width: "55px",
    height: "55px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },

  techHeading: {
    fontSize: "16px",
    fontWeight: "600",
    // color: color.text,

  },
  total: {
    fontSize: "16px",
    fontWeight: "600",
    borderTop: "1px solid #DEDEDE",

  },

  textinfo: {
    fontSize: "12px",

  },

  inputBox: {
    width: {xs:"100%", md: "49%", lg:"27%"},
    mr:1,
  },
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    // mt: 1,
  },
  uploadText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    mt: 2,
    mb: 1,
 
  },
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },
  gridboxs: {
    backgroundColor: "#ffff",
    mt:0,
    mx: 2,
    mb:2,
    py: 4,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },

  itemSection: { 
    display: "flex",
    mx:2,
    alignItems: "center",
    width: "100%",

  },
  gridText: {
    mx:2,
    fontSize: "14px",
    fontWeight: "600"
  },
  tableHead: {
    color: color.lightText
  },

  tableSection:{
    mt:4,
    mx: 2
  },
  tabledata: {
    borderBottom: 0,
  
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display:"flex",
    flexDirection:"row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    pr: 2,
    display: "flex",
    justifyContent: "end",
    my:2

  },
  jobButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A", 
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,
    mt:"18px"
  },
  totalSection: {
    textAlign: "end",

  },

  mainContainer:{
    justifyContent: "end",
    // pr:{xs:1, md:1}
  },
  dropdown:{
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px",
    },
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    fontSize:"14px",
    fontWeight:"400",
    mt:1,
  },
  createJob: {
    px: "15px",
    // mb:2,
  },
  monthlyBtn:
  { borderRadius: 50,
    ml: "8px" ,
    textTransform: "none", 
    fontSize: "14px",
    boxShadow:"none",
    fontWeight: "500",
    

  },
  checkoutBtn: {
    borderRadius: 50, 
    ml: 3,
    textTransform: "none",
    fontSize: "14px",
    boxShadow:"none",
    fontWeight: "500",

  },
  incomeText: {
    fontSize: "18px",
    fontWeight: "500",
    mb: 2
  },
  incomeGrid: {
    display: "flex",
    mb:3

  },
  incomeKey: {
    fontWeight: "500",
    fontSize: "14px",


  },
  incomeKeys: {
    fontWeight: "600",
    fontSize: "14px",

  },
  incomeKeyCash: {
    fontWeight: "700",
    fontSize: "14px",


  },
  incomevalue: {
    fontSize: "14px",

  },
  incomevalueRed: {
    fontSize: "14px",
    color: color.red

  },
  keySection: {
    width: "30%"
  },
  incomeValue: {
    fontWeight: "500",
    fontSize: "14px",

    width: "50%"
  },

  line: {
    border: "1px solid #DEDEDE ",
    width: "100%",
    my:1
  },
  lines: {
    border: "1px solid #DEDEDE ",
    width: "100%",
    mt:1,
    mb:2,
  }


}; 
 
export default style;